import usePagination from "@/hooks/usePagination";
import { useMemo } from "react";
import useGetCreditTransferListForRegistry from "./useGetCreditTransferListForRegistry";

export const useGetCreditTransferListForRegistryPagination = () => {
	const pagination = usePagination();
	const creditTransferList = useGetCreditTransferListForRegistry(pagination.limit, pagination.offset);
	return useMemo(
		() => ({
			creditTransferList,
			pagination,
		}),
		[creditTransferList, pagination],
	);
};
